import '@fortawesome/fontawesome-pro/js/all.min';
import 'slick-carousel';
import './vendor/jquery-popup-overlay';

import './site/polyfills';
import './site/navigation';
import './site/popup';
import './site/form';
import './site/birthday-club';
import './site/hero';
import './site/reveal-slider';
import './site/video';
import './site/header';
import './site/experience';
import './site/events';
import './site/menus';
import './site/reserve-table';
import './site/404';
import './site/fallbacks';
import './site/scratch';
import initAccordion from './site/accordion';
import { isEditMode, scrollToElement } from './site/helpers';

import * as ADMIN_CONSTANTS from './admin/admin-constants';

window.ADMIN_CONSTANTS = ADMIN_CONSTANTS;

function setHeaderMargin() {
	const headHeight = $('#header').height();
	$('#body-content').css('margin-top', headHeight);
}

if (!isEditMode) {
	$('#css-main').on('load', setHeaderMargin);

	if ('ResizeObserver' in window) { // I'll give Chrome credit for implementing this one :eyeroll:
		const observer = new ResizeObserver(setHeaderMargin);

		observer.observe(document.querySelector('#header'));
	} else if ('MutationObserver' in window) { // Most other browsers
		const observer = new MutationObserver(setHeaderMargin);

		observer.observe(document.querySelector('#header'), {
			attributes: true,
			childList: true,
			characterData: true,
			subtree: true
		});
	} else {
		$(window).on('load', setHeaderMargin);
	}
}

const styles = document.querySelectorAll('link[disabled]');

for (let i = 0; i < styles.length; i++) {
	styles[i].removeAttribute('disabled');
}

$(function () {
	$('a[href^=http]').attr('target', '_blank'); // external links
	if("#grubhub-link"){
		console.log("ding");
		document.getElementById('grubhub-link').setAttribute("onclick", "ga('send','event','button','click','grubhub')")
	};
	//init Accordions
	if ($('.accordion-angle').length) {
		$('.accordion-angle').each(function () {
			initAccordion($(this), 'fa-caret-down', 'fa-caret-right');
		});
	}

	$('.footer-actions').on('click', '.footer-actions-hours-toggle', (e) => {
		e.preventDefault();
		$('.footer-actions-hours').slideToggle();
	});

	$(document).on('click', 'a[href^="#"]', function (e) {
		const targetSelector = $(this).attr('href');

		if (targetSelector === '#' && $(this).hasClass('back-to-top')) {
			$('html, body').animate({
				scrollTop: 0
			}, 1000);
			return false;
		}

		if (scrollToElement(targetSelector)) e.preventDefault();
	});
});
